import {executeOpenCommand} from '../../../_shared/GWTBridge/invoke/genPage';
import {action, actionEnd} from '../../../services/form/form';
import {Column, Form, apiLocker, formsStore} from '../../../stores/Form';
import {priority} from '@priority-software/priority-proto-api/lib';
import {reorganizeRecordsAfterDelete} from './delete';
import {getUpdateActionType} from '../../../stores/Form/utils';
import {EntityType} from '../consts/EntityTypes';
import {isNewApiForm, runForm} from '../../../_shared/GWTBridge/invoke/netForm';
import {actionZoom} from './zoom';
import {fieldValue} from '../../../stores/Form/Field';

export const startDirectActivation = async (form: Form, act: priority.netitems.form.IAction) => {
    const screen = formsStore.getScreenBySession(form.session);
    const valueActionType = getUpdateActionType(form, true, screen.editMode);
    const isValidAction = await screen.checkAndSave(valueActionType);
    if (isValidAction) {
        if (act.Type === EntityType.FORM) {
            const ename: string = act.Ename;
            if (isNewApiForm(ename)) {
                actionZoom(form, ename);
            } else {
                const column: Column = form.currentColumn;
                const value: fieldValue = form.currentRecord.getField(column.id).currentValue;
                runForm(
                    ename,
                    Number(column.Column),
                    column.Name,
                    value.toString(),
                    true,
                    false,
                    form.dname
                );
            }
        } else {
            executeDirectActivation(form, act);
        }
    }
};

export const restartDirectActivation = async (session: string, ename: string) => {
    const form = formsStore.getFormBySession(session);
    const action = form.actions.find(a => a.Ename === ename);
    executeDirectActivation(form, action);
};

export const executeDirectActivation = async (form: Form, act: priority.netitems.form.IAction) => {
    const {records, session, currentRow} = form;

    const keys = records[form.currentRow].keys;
    const scrLine = currentRow;
    const actionRes = await action(session, scrLine, keys, form.dname);
    // lock session manualy because all the rest of the action happens in old api that doesn't block new UI
    if (!act.Background) {
        apiLocker.lockSession(form.session);
    }
    const link = {
        link: actionRes.LinkFile,
        linkid: actionRes.LinkID,
        table: actionRes.Table
    };
    executeOpenCommand(
        act.Ename,
        String.fromCharCode(Number(act.Etype)),
        link.link,
        link.linkid,
        link.table,
        session,
        form.dname
    );
};

export const endDirectActivation = async (session: string) => {
    const actionEndRes = await actionEnd(session);
    const form = formsStore.getFormBySession(session);
    if (actionEndRes.Record) {
        form.updateRecordValues(form.currentRow, actionEndRes.Record.Fields);
    } else {
        form.deleteClientRecord(form.currentRow);
        form.setSubForm(null);
        if (form.allRecordsCount) {
            form.setAllRecordsCount(form.allRecordsCount - 1);
        }
        reorganizeRecordsAfterDelete(form);
    }
};
